const PrivacyConfig = {
  links: [
    { name: "Privacy Policy", url: "/privacy" },
  ],

  privacy: {
    title: "Privacy Policy",
    name: "Privacy Policy",
    sections: [
      {
        introduction:
          "At gsussoftware.in, we value and respect your privacy. This Privacy Policy outlines how we collect, use, disclose, and safeguard your personal information when you visit our website. By accessing or using www.gsussoftware.in (the “Website”), you agree to the practices described in this policy.",

        heading: "1. Information We Collect",
        content: [
          {
            subheading: "Personal Information:",
            text: "When you visit our Website, we may collect personal information that you voluntarily provide, such as your name, email address, contact information, and any other details you choose to submit through our contact forms or registration processes.",
          },
          {
            subheading: "Automatically Collected Information:",
            text: "We may also automatically collect certain information about your visit to the Website, such as your IP address, device information, browser type, operating system, and browsing behavior. This is collected via cookies, web beacons, and similar technologies.",
          },
        ],
      },
      {
        heading: "2. How We Use Your Information",
        content: [
          {
            subheading: "Provide and Improve Services:",
            text: "We use the collected information to deliver requested services, improve functionality and user experience, and better understand visitor interactions. We may also use your contact details for communication about updates, promotions, or support. You can opt out anytime.",
          },
          {
            subheading: "Communication:",
            text: "We may use your contact information to communicate with you regarding updates, promotions, or relevant information about our products and services. You can opt-out of receiving such communications at any time.",
          },
          {
            subheading: "Analytics and Insights:",
            text: "We may analyze the information we collect to better understand user behavior, preferences, and trends, allowing us to improve our services and offerings.",
          },
        ],
      },
      {
        heading: "3. Cookies and Similar Technologies",
        content: [
          {
            text: "Cookies are used to enhance browsing, personalize content, and analyze site usage. You can manage your cookie preferences through browser settings.",
          },
        ],
      },
      {
        heading: "4. Disclosure of Information",
        content: [
          {
            text: "We may share personal information with trusted service providers who assist in operating our website and services, bound by confidentiality obligations. We may also disclose data for legal reasons or during business transactions like mergers or acquisitions.",
          },
        ],
      },
      {
        heading: "5. Data Security",
        content: [
          {
            subheading: "Service Providers:",
            text: " We may engage trusted third-party service providers to assist us in providing the services offered on the Website. These service providers will have access to your personal information only to perform specific tasks on our behalf and are obligated not to disclose or use it for any other purpose.",
          },
           {
            subheading: "Legal Compliance: ",
            text: "We may disclose your information if required by law, regulation, legal process, or government request.",
          },
           {
            subheading: "Business Transactions:",
            text: "In the event of a merger, acquisition, or sale of all or a portion of our assets, your information may be transferred as part of the transaction. We will notify you through prominent notice on our Website before your personal information is transferred and becomes subject to a different privacy policy.",
          },
        ],
      },
      {
        heading: "6. Third-Party Links",
        content: [
          {
            text: "Our Website may include links to external sites not operated by gsussoftware.in. We encourage reviewing those sites’ privacy policies before providing any personal data.",
          },
        ],
      },
      {
        heading: "7. Children’s Privacy",
        content: [
          {
            text: "Our Website is not directed toward children under 13. We do not knowingly collect data from children. If we become aware of such collection, we will promptly delete the data.",
          },
        ],
      },
      {
        heading: "8. Changes to This Policy",
        content: [
          {
            text: "We may periodically update this Privacy Policy to reflect changes in practices or legal requirements. Updates will be posted on this page with a revised effective date.",
          },
        ],
      },
      {
        heading: "9. Contact Us",
        content: [
          {
            text: "If you have questions or concerns regarding this Privacy Policy or data handling practices, please reach out to us at info@gsussoftware.com.",
          },
          {
            text: "By using www.gsussoftware.in, you signify your acceptance of this Privacy Policy. Please read this policy carefully and regularly check for updates.",
          },
        ],
      },
    ],
    conclusion:
      "Thank you for entrusting us with your personal information. Your privacy is of utmost importance to us.",
  },
};

export default PrivacyConfig;